/*
 * @providesModule BalanceBarV2Style
 *
 */
import Sizes from 'Sizes';
import SkillzStyle from 'SkillzStyle';
import {Dimensions, Platform, StyleSheet} from 'react-native';

const {viewPrimaryColor, textColorPrimary} = SkillzStyle.fullStyles;

export default StyleSheet.create({
  balanceView: {
    ...viewPrimaryColor,
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: Dimensions.get('window').width,
    paddingHorizontal: 12,
    borderBottomColor: SkillzStyle.convertToOpacity(
      '#000000',
      SkillzStyle.useValueForTheme(0.1, 0.5)
    ),
    borderBottomWidth: 1,
  },

  balanceContainer: {
    backgroundColor: 'transparent',
    marginRight: 8,
  },

  currencyContainer: {
    flexDirection: 'row',
    flex: 1,
  },

  counterView: {
    flexDirection: 'column',
    alignItems: 'center',
    flex: 1,
  },

  countingLabel: {
    textAlign: 'center',
    justifyContent: 'center',
    backgroundColor: 'transparent',
  },

  countingLabelContainer: {
    flexDirection: 'row',
    alignSelf: 'center',
    flex: 1,
    backgroundColor: 'transparent',
  },

  chatContainer: {
    alignSelf: 'center',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    marginRight: 10,
    width: 24,
  },

  badge: {
    position: 'absolute',
    top: -2,
    right: -4,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 5,
    backgroundColor: 'red',
    height: 8,
    width: 8,
  },

  noNumberBadge: {
    borderRadius: 20,
    backgroundColor: textColorPrimary.color,
    ...Sizes.select({
      phone: {
        height: 4,
        width: 4,
      },
      tablet: {
        height: 5,
        width: 5,
      },
    }),
  },

  chatIcon: {
    ...(Platform.OS === 'ios' ? {marginTop: 2} : {}),
    marginLeft: 5,
    width: 24,
    height: 23,
  },

  backgroundThemingOverride: {
    backgroundColor: SkillzStyle.convertToOpacity('#FFFFFF', 0.2),
  },

  lightThemeOverride: {
    borderColor: SkillzStyle.convertToOpacity('#000000', 0.15),
    borderRadius: 20,
    borderWidth: 1,
    borderStyle: 'solid',
  },

  darkThemeOverride: {
    borderColor: SkillzStyle.convertToOpacity('#FFFFFF', 0.2),
    borderRadius: 20,
    borderWidth: 1,
    borderStyle: 'solid',
  },

  skillzPowered: {
    ...Sizes.select({
      phone: {
        width: 52,
        height: 23,
      },
      tablet: {
        width: 82,
        height: 36,
      },
    }),
    flexDirection: 'column',
    justifyContent: 'center',
    alignSelf: 'center',
  },
});
